import styled from '@emotion/styled';

export const ImageOverlay = styled.div(({ theme }) => ({
    position: 'absolute',
    inset: 0,
    background: theme.colors.grey10,
    mixBlendMode: 'multiply',
}));
